import styled from 'styled-components';
import { border, color, layout, lineHeight, position, shadow, space, system } from 'styled-system';
import { baseTheme } from '../../styles';
import { shouldForwardProp } from './utils';
export var flexboxItem = system({
  flex: true,
  flexGrow: true,
  flexShrink: true,
  flexBasis: true,
  justifySelf: true,
  alignSelf: true,
  order: true
});
var gridItem = system({
  gridArea: true,
  gridColumn: true,
  gridRow: true,
  gridColumnStart: true,
  gridColumnEnd: true,
  gridRowStart: true,
  gridRowEnd: true
});
var customProps = system({
  cursor: true,
  userSelect: true
});
/**
 * A plain div which supports arbitrary margins and paddings, where necessary.
 * 🚨Use scarcely!
 */

var Box = styled.div.withConfig({
  shouldForwardProp: shouldForwardProp
}).withConfig({
  displayName: "Box",
  componentId: "sc-14d2slk-0"
})(["", " ", " ", " ", " ", " ", " ", " ", " ", " ", ""], space, layout, position, shadow, border, color, flexboxItem, gridItem, lineHeight, customProps);
Box.defaultProps = {
  theme: baseTheme,
  display: 'block'
};
export default Box;